import React from 'react'
import useOperation from '../hooks/use-operation'
import { useConstrainable } from '@morningtrain/react-filters'
import useOnOperationExecute from '../hooks/use-on-operation-execute'

export default function SetFilterMetaOnConstrainable () {
  const operation = useOperation()
  const constrainable = useConstrainable()

  constrainable.updateFilterMeta(operation.filters, false)

  useOnOperationExecute(() => {
    constrainable.updateFilterMeta({
      ...operation.filters,
      ...operation.getMeta('filters', {})
    })
  })

  return null
}
